import script from "./AiDocumentScanDefaultView.vue?vue&type=script&setup=true&lang=js"
export * from "./AiDocumentScanDefaultView.vue?vue&type=script&setup=true&lang=js"

import "./AiDocumentScanDefaultView.vue?vue&type=style&index=0&id=96310158&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96310158"]])

export default __exports__